import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import firebase from '../../constants/firebase'


const RequestPasswordResetForm = ({ history }) => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [error, setError] = useState(null)

    function onSubmit(event) {
        event.preventDefault();
        firebase
            .auth()
            .sendPasswordResetEmail(email)
            .then((ret) => {
                navigate('../verify')
            })
            .catch(error => {
                setError(error.message);
            });
    };

    function onChange(event) {
        setEmail(event.target.value)
    };

    return (
        <div className="mt-6">
            <form onSubmit={onSubmit} className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Email address</label>
                    <div className="mt-1">
                        <input onChange={onChange} id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" ></input>
                    </div>
                </div>
                <div>
                    <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-ltgreen hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Get Password Reset Code
                        </button>
                </div>
                {error ? (<p fontColor='red'>{error}</p>) : null}
                <div className="flex items-center justify-between">
                    <div className="text-sm">
                        <Link to="/auth/signin" className="font-medium text-black hover:text-ltgreen">Cancel</Link>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default RequestPasswordResetForm